import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { useDebounce } from "use-debounce";

import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getEventsRequest } from "../../store/events/actions";
import { EventTable } from "./EventTable";

const EventList = () => {
  document.title = "Eventos | Ecoguias - Admin Dashboard";
  const history = useHistory();

  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.Events);

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  useEffect(() => {
    dispatch(getEventsRequest(value));
  }, [dispatch, value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Tabela de eventos" pageTitle="Eventos" />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={() => history.push("/events-form")}
            >
              Cadastrar
            </button>
          </div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Eventos</h5>
                </CardHeader>
                <CardBody>
                  <EventTable
                    style={{ width: "100%" }}
                    events={data?.result ?? []}
                    loading={loading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EventList;
